module.exports = __webpack_public_path__ + "img/switzerland-neoplasm-male.56ff80b4.png";